import { collection, query, where, getDocs, writeBatch, doc, getDoc } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import { getUserById } from '../../queries/users';

const COLLECTIONS_TO_CLEAN = [
  'habits',
  'appointments',
  'groupMembers',
  'groupPosts',
  'groupMessages',
  'points',
  'userRewards',
  'courseProgress',
  'userNotes',
  'availabilities',
  'examinations'
] as const;

export async function cleanupUserData(userId: string): Promise<void> {
  const batch = writeBatch(db);

  try {
    // Get user data to retrieve phone number before deletion
    const user = await getUserById(userId);
    
    // Delete user document
    batch.delete(doc(db, 'users', userId));

    // Clean up user data from all related collections
    for (const collectionName of COLLECTIONS_TO_CLEAN) {
      const q = query(
        collection(db, collectionName),
        where('userId', '==', userId)
      );
      
      const snapshot = await getDocs(q);
      snapshot.docs.forEach(doc => {
        batch.delete(doc.ref);
      });
    }

    // Clean up phone reservation if user has a phone number
    if (user?.phone) {
      const phoneRef = doc(db, 'phones', user.phone);
      const phoneDoc = await getDoc(phoneRef);
      
      if (phoneDoc.exists()) {
        const phoneData = phoneDoc.data();
        // Only delete if this phone belongs to the user being deleted
        if (phoneData?.userId === userId) {
          batch.delete(phoneRef);
        }
      }
    }

    // Commit all deletions
    await batch.commit();
  } catch (error) {
    handleFirebaseError(error, 'Error cleaning up user data');
    throw error;
  }
}